import moment from "moment";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import adjustDaysDataOfMonth from "./adjustDaysDataOfMonth";

/**
 * Klass VuwMinimalCalendar
 *
 * @options
 * - {moment} viewDate: 基準日 (default: now)
 * - {object} holidays: 休日オブジェクト
 * - {object} events: イベントオブジェクト
 * - {array} weekdaysKeys: 曜日ごとのクラス名
 * - {int} firstDayOfWeek: 左端の曜日 (dafault: 0 sunday)
 * - {string} strPrevMonth: 前月表示のHTMLテキスト
 * - {string} strNextMonth: 翌月表示のHTMLテキスト
 * - {function} onPicupEventsData: イベントデータ操作時のコールバック
 * - {function} onRenderDay: 日付エレメント生成時のコールバック
 * - {function} onChangeMonth: 表示更新時のコールバック
 */
vuwer.appendKlass("VuwMinimalCalendar", {
	weekdaysKeys: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
	weekdaysTexts: moment.weekdaysShort(),
	classPrefix: "vuw-mcal-",
	
	firstDayOfWeek: 0,	// 0 -> sunday
	strPrevMonth: "<span>前月</span>",
	strNextMonth: "<span>翌月</span>",
	onRenderDay($day, dataAttr, eventsOfDay) {},
	onChangeMonth(viewDate, $container, holidaysOfMonth, eventsOfMonth) {},
	onPicupEventsData(mmntDate, data) {},
	onEventClick($event, data) {},
	
	// ** [コンストラクタ] **
	_initialize(opt) {
		const _super_ = Klass("VuwMinimalCalendar").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		// viewDate
		moment.isMoment(this.viewDate) || ( this.viewDate = moment(this.viewDate) );
		
		// holidays
		this.setHolidays(this.holidays);
		
		// events
		this.setEvents(this.events);
		
		// weekdaysKeys
		if(
			u_.hasProperty(this, "weekdaysKeys") && (
				!Array.isArray(this.weekdaysKeys) ||
				this.weekdaysKeys.length < this.weekdaysTexts.length
			)
		) {
			delete this.weekdaysKeys;
		}
		
		// firstDayOfWeek
		u_.isNumber(this.firstDayOfWeek) || (this.firstDayOfWeek = 0);
		
		// [add onReady callback]
		this.onReady(this._onReadyDefault);
		
		// ** add child vuw **
		// [header]
		this.add("header", {
			vuwType: "minimalCalendarHeader",
			classPrefix: this.classPrefix,
			prevText: this.strPrevMonth,
			nextText: this.strNextMonth
		});
		
		// [body]
		const bodyProps = {
			vuwType: "minimalCalendarBody",
			classPrefix: this.classPrefix,
			weekdaysTexts: this.weekdaysTexts,
			weekdaysKeys: this.weekdaysKeys,
			firstDayOfWeek: this.firstDayOfWeek,
			onRenderDay: this.onRenderDay,
			onEventClick: this.onEventClick
		};
		
		if(bodyProps.firstDayOfWeek) {
			bodyProps.weekdaysTexts = [
				...bodyProps.weekdaysTexts.slice(bodyProps.firstDayOfWeek),
				...bodyProps.weekdaysTexts.slice(0, bodyProps.firstDayOfWeek)
			];
			
			bodyProps.weekdaysKeys = [
				...bodyProps.weekdaysKeys.slice(bodyProps.firstDayOfWeek),
				...bodyProps.weekdaysKeys.slice(0, bodyProps.firstDayOfWeek)
			];
		}
		
		this.add("body", bodyProps);
		
		return this;
	},
	
	_onReadyDefault($self) {
		const { classPrefix } = this;
		
		$self.addClass(`${classPrefix}container`)
		.on("click", `.${classPrefix}prev > a`, e => {
			e.preventDefault();
			this.changeMonth(-1);
		})
		.on("click", `.${classPrefix}next > a`, e => {
			e.preventDefault();
			this.changeMonth(1);
		});
		
		this.changeMonth();
	},
	
	setHolidays(data) {
		this.holidays = u_.isObject(data) ? data : {};
		return this;
	},
	
	setEvents(data) {
		Array.isArray(data) && (data = { always: data });
		this.events = u_.isObject(data) ? data : {};
		return this;
	},
	
	async changeMonth(addMonths) {
		const { viewDate } = this;
		
		if( u_.isNumber(addMonths) ) {
			viewDate.add(addMonths, "months");
		}
		
		const viewYM = {
			y: viewDate.format("YYYY"),
			m: viewDate.format("M")
		};
		
		this.$self.attr({
			"data-year": viewYM.y,
			"date-month": viewYM.m,
			"date-day": viewDate.format("D")
		});
		
		
		// [holidays of view month]
		// "day"で指定されている休日データに"daysIdx"と"weekPos"を設定
		const holidays = Array.isArray(this.holidays[viewYM.m]) ? adjustDaysDataOfMonth(
			viewDate,
			this.holidays[viewYM.m],
			(mmnt, data) => {
				if( !mmnt.days() ) {
					// 日曜日に被ったら翌日に振り替え
					mmnt.add(1, "days");
					!!data.name && (data.name += "（振替）");
				}
			}
		) : [];
		
		
		// [events of view month]
		// always
		const eventList = Array.isArray(this.events.always) ? [...this.events.always] : [];
		
		// events of view month
		Array.isArray(this.events[viewYM.m]) && eventList.push(...this.events[viewYM.m]);
		
		// "day"で指定されているイベントデータに"daysIdx"と"weekPos"を設定
		const events = adjustDaysDataOfMonth(
			viewDate,
			eventList,
			u_.isFunction(this.onPicupEventsData) && ((mmnt, data) => {
				return this.onPicupEventsData(mmnt, data, holidays);
			})
		);
		
		
		await Promise.all([
			this.get("header").setState({
				year: viewYM.y,
				month: viewYM.m
			}),
			this.get("body").setState({
				ym: viewDate.format("YYYY-MM"),
				holidays,
				events
			})
		]);
		
		u_.isFunction(this.onChangeMonth) && this.onChangeMonth(
			viewDate.clone(),
			this.$self,
			holidays,
			events
		);
	}
});


// [define static functions]
Object.assign(Klass("VuwMinimalCalendar"), { adjustDaysDataOfMonth });
